import React from 'react';
import styles from './styles';

import { Typography, Container, AppBar } from '@material-ui/core';
import logoGaleno from '../../../assets/img/logo-galeno.png';
import iconoPrestador from '../../../assets/iconos/prestador.svg';
import history from '../../../services/history';
import Tutoriales from '../Tutoriales/Tutoriales';
import { useEffect } from 'react';
import axios from '../../../http-common';
import * as actions from "../../../actions/grillaPrincipal";
import { connect } from 'react-redux';

const Header = (props) => {
    const classes = styles();

    useEffect(() => {
        if (props.codPrestador && sessionStorage.getItem('alertaChecked') !== "true") {
            axios.get(`/profile/alertaprestador/${props.codPrestador}`)
            .then(res => {
                if (res.data.alertaPrestador) {
                    props.mostrarAvisoPrestadores();
                }
                sessionStorage.setItem('alertaChecked', "true");
            })
        }
    }, [props.codPrestador])

    return (
        <AppBar className={classes.barra}>
            <Container className={classes.container} disableGutters={true}>
                <Container style={{padding: 0}}>
                    <Container className={classes.containerLogoVersion}>
                        <Container
                            className={classes.containerLogo}
                            disableGutters={true}
                            onClick={() => history.push('/')}
                            >
                            <img
                                className={classes.logo}
                                src={logoGaleno}
                                alt='logo-imagen'
                            />
                        </Container>
                        <Typography
                            display='inline'
                            color='primary'
                            className={classes.version}
                            >
                            {"V "}
                            <span style={{display: 'block', marginLeft: '2px'}}>{process.env.REACT_APP_VERSION}</span>
                        </Typography>
                    </Container>
                </Container>
                <Container
                    className={classes.containerTitulo}
                    disableGutters={true}
                >
                    <Typography className={classes.titulo}>
                        Ingreso documentación prestadores
                    </Typography>
                </Container>
                <Container
                    className={classes.containerPrestador}
                    disableGutters={true}
                >
                    <Tutoriales />
                    <div className={classes.containerIcono}>
                        <img
                            className={classes.icono}
                            src={iconoPrestador}
                            alt='icono-prestador'
                        />
                    </div>
                    <Typography className={classes.codPrestador}>
                        {props.codPrestador}
                    </Typography>
                </Container>
            </Container>
        </AppBar>
    );
};

const mapStateToProps = (state) => ({});

const actionCreators = {
    mostrarAvisoPrestadores: actions.mostrarAvisoPrestadores
};

export default connect(mapStateToProps,actionCreators)(Header);